import * as React from "react";
import OrganizationManager from "@/components/organization/OrganizationManager";

export default function ProspectOrganizationTab({ prospectId }: { prospectId: number }) {
  return <OrganizationManager ownerType="prospect" ownerId={prospectId} />;
}
